import { createAction } from '@mews/framework/redux';
import {
    FETCH_PAYMENT_CARDS_FAILED,
    FETCH_PAYMENT_CARDS_STARTED,
    FETCH_PAYMENT_CARDS_SUCCEEDED,
} from '../../modules/entities/paymentCards/actionTypes';
import type { DistributorThunkAction } from '../../types';

export const fetchPaymentCards =
    ({ paymentCardIds }: { paymentCardIds: string[] }): DistributorThunkAction =>
    async (dispatch, _getState, { apiService }) => {
        dispatch(createAction(FETCH_PAYMENT_CARDS_STARTED, { paymentCardIds }));

        return apiService
            .getPaymentCards({ paymentCardIds })
            .then((response) => {
                dispatch(createAction(FETCH_PAYMENT_CARDS_SUCCEEDED, response));
                return response;
            })
            .catch((error) => {
                dispatch(createAction(FETCH_PAYMENT_CARDS_FAILED, { error }));
                throw error;
            });
    };
